module.exports = __webpack_public_path__ + "img/web2icon5.eecfcd19.png";